module.exports = __webpack_public_path__ + "static/fish_bg_right-a870ecc4bb97810e6e4f5eaf3a7e13bb.png";